import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/computer-device-desktop-monitor.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M216 64h-68.69l34.35-34.34a8 8 0 1 0-11.32-11.32L128 60.69 85.66 18.34a8 8 0 0 0-11.32 11.32L108.69 64H40a16 16 0 0 0-16 16v120a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16M40 80h104v120H40Zm176 120h-56V80h56zm-16-84a12 12 0 1 1-12-12 12 12 0 0 1 12 12m0 48a12 12 0 1 1-12-12 12 12 0 0 1 12 12" }, null, -1)])]);
}
var computer_device_desktop_monitor_default = { render };
//#endregion
export { computer_device_desktop_monitor_default as default, render };

//# sourceMappingURL=computer-device-desktop-monitor.svg.js.map